// extracted by mini-css-extract-plugin
export default {"tableStyle":"TagsTableDetail_tableStyle__a7GKM"};